"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _index = _interopRequireDefault(require("@/components/filterColumn/index.vue"));
var _index2 = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _billConsigneeApplication = require("@/api/userCenter/billConsigneeApplication");
var _billButtons = _interopRequireDefault(require("@/views/userCenter/componens/billButtons.vue"));
var _myBookingTemplate = require("@/api/bookSpace/myBookingTemplate");
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "myBookingTemplate",
  components: {
    Pagination: _index2.default,
    billButtons: _billButtons.default,
    filterColumn: _index.default
  },
  data: function data() {
    return {
      dataTotal: 0,
      billRules: {
        accountNo: [{
          required: true,
          message: '请输入港口',
          trigger: 'blur'
        }],
        companyName: [{
          required: true,
          message: '请输入公司名称',
          trigger: 'blur'
        }],
        companyNameCn: [{
          required: true,
          message: '请输入公司名称(CN)',
          trigger: 'blur'
        }],
        usci: [{
          required: true,
          message: '请输入USCI',
          trigger: 'blur'
        }]
      },
      editDialog: false,
      dialogType: '',
      hotSettings: {
        dragCheck: true,
        height: '500',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      dateValueFormItem: '',
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      teplateData: [],
      portOptions: [{
        value: 'CNSHA',
        label: 'CNSHA'
      }],
      billForm: {
        companyName: '',
        companyNameCn: '',
        usci: '',
        portCode: ''
      },
      searchForm: {
        bkNo: '',
        dateTimeStart: '',
        dateTimeEnd: '',
        containerType: '',
        stuff: '',
        delName: ''
        // dateTimeStart: '2018-01-01 16:00:00.000',
        // dateTimeEnd: '2018-01-31 16:00:00.000',
        // containerType: 'RF',
      },
      userInfo: {},
      selectionIds: [],
      statusValueList: [{
        value: 0,
        label: '待提交'
      }, {
        value: 1,
        label: '待审核'
      }, {
        value: 2,
        label: '已审核'
      }, {
        value: 3,
        label: '取消审核'
      }],
      isCancelSubmit: false,
      isCancelDel: false,
      paidTypeList: [],
      containerTypeList: []
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  created: function created() {
    var _this = this;
    this.$dictionary.get(['PAID_TYPE'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      console.log(res, 'res');
      _this.paidTypeList = res.PAID_TYPE;
    });
    var data = {
      pageSize: 1000,
      currentPage: 1
    };
    (0, _booking.queryListCode)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
      type: "EQUIPMENT"
    })).then(function (res) {
      _this.containerTypeList = res.data;
      console.log('this.containerTypeList', _this.containerTypeList);
    });
  },
  activated: function activated() {
    this.searchFormData();
  },
  mounted: function mounted() {
    var _this2 = this;
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    console.log('    this.userInfo', this.userInfo);
    this.$nextTick(function () {
      _this2.resizeHotTable();
    });
    var test = this.getPaidTypeListLabel('0');
    console.log('++++++++++test', test);
  },
  methods: {
    getPaidTypeListLabel: function getPaidTypeListLabel(value) {
      var _this3 = this;
      var text = '666';
      this.paidTypeList.map(function (item, index) {
        console.log('item.codeValue , value,this.language ', item.codeValue, value, _this3.language);
        if (item.codeValue == value) {
          if (_this3.language == 'zh') {
            console.log('item.displayValueCn', item.displayValueCn);
            text = item.displayValueCn;
          } else {
            text = item.displayValue;
          }
        }
      });
      return text;
    },
    goToTemplateDetail: function goToTemplateDetail(item, type) {
      console.log('item.templateBookingHeadComId', item.templateBookingHeadComId);
      this.$router.push({
        path: '/bookingSpace/myBookingTemplateDetail',
        query: {
          templateBookingHeadComId: item.templateBookingHeadComId,
          templateType: type
        }
      });
    },
    goToTemplateDetailBook: function goToTemplateDetailBook(item, type) {
      console.log('item.templateBookingHeadComId', item.templateBookingHeadComId);
      this.$router.push({
        path: '/bookingSpace/bookingSpaceDetail',
        query: {
          id: item.templateBookingHeadComId,
          templateType: type
        }
      });
    },
    addTemplate: function addTemplate(type) {
      this.$router.push({
        path: '/bookingSpace/myBookingTemplateDetail',
        query: {
          templateBookingHeadComId: '',
          templateType: type
        }
      });
    },
    deleteTemplate: function deleteTemplate(item) {
      var _this4 = this;
      this.$confirm(this.$t('booking.bookingTemplate.deleteConfirm'), this.$t('booking.bookingTemplate.deletTip'), {
        cancelButtonText: this.$t('userCenter.billConsigneeApplication.cancelButton'),
        confirmButtonText: this.$t('userCenter.billConsigneeApplication.confirmButton'),
        type: 'warning'
      }).then(function () {
        _this4.loading = (0, _utils.load)();
        (0, _myBookingTemplate.deleteTemplateById)(item.templateBookingHeadComId).then(function (res) {
          if (res.success) {
            _this4.$message({
              message: _this4.$t('booking.bookingTemplate.deleteSuccess'),
              type: 'success'
            });
            _this4.searchFormData();
          }
        }).finally(function () {
          _this4.loading.close();
        });
      });
    },
    dateTimeChange: function dateTimeChange(data) {
      console.log('data', data);
      this.searchForm.dateTimeStart = data[0];
      this.searchForm.dateTimeEnd = data[1];
    },
    closeDialog: function closeDialog() {
      this.billForm = {
        companyName: '',
        companyNameCn: '',
        usci: '',
        portCode: ''
      };
    },
    resizeHotTable: function resizeHotTable() {
      // this.$refs.hotTableCost.resizeTo()
    },
    resetForm: function resetForm() {
      this.searchForm = {
        bkNo: '',
        dateTimeStart: '',
        dateTimeEnd: '',
        containerType: '',
        stuff: '',
        delName: ''
      };
      this.dateValueFormItem = '';
    },
    searchFormData: function searchFormData() {
      var _this5 = this;
      this.searchForm.bkNo = this.searchForm.bkNo.trim();
      this.searchForm.containerType = this.searchForm.containerType.trim();
      var data = this.searchForm;
      data.currentPage = this.listQuery.currentPage;
      data.pageSize = this.listQuery.pageSize;
      console.log('this.searchForm', this.searchForm);
      this.loading = (0, _utils.load)();
      (0, _myBookingTemplate.getEbTemplateBookingHeadCom)(data).then(function (res) {
        console.log('res', res);
        _this5.teplateData = res.data.records;
        // this.listQuery.total = res.data.totalRecord;
      }).catch(function (err) {
        console.log('err', err);
      }).finally(function () {
        _this5.loading.close();
      });
    },
    // formatDate(time) {
    //   var date = new Date(time)
    //   var y = date.getFullYear()
    //   var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
    //   var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
    //   return y + '-' + m + '-' + d
    // },
    saveFormClick: function saveFormClick() {
      var _this6 = this;
      this.$refs.billFormRef.validate(function (valid) {
        if (valid) {
          if (_this6.dialogType == 'add') {
            _this6.loading = (0, _utils.load)();
            (0, _billConsigneeApplication.addWebBlConsigneeCertification)(_this6.billForm).then(function (res) {
              console.log('res', res);
              _this6.editDialog = false;
              _this6.searchFormData();
              _this6.$message({
                message: _this6.$t('userCenter.billConsigneeApplication.addSuccess'),
                type: 'success'
              });
            }).catch(function (err) {
              console.log('err', err);
              _this6.$message({
                message: err.errorMessages[0],
                type: 'error'
              });
            }).finally(function () {
              _this6.loading.close();
            });
          } else if (_this6.dialogType == 'edit') {
            _this6.loading = (0, _utils.load)();
            (0, _billConsigneeApplication.saveWebBlConsigneeCertification)(_this6.billForm).then(function (res) {
              console.log('res', res);
              _this6.editDialog = false;
              _this6.searchFormData();
              _this6.$message({
                message: _this6.$t('userCenter.billConsigneeApplication.editSuccess'),
                type: 'success'
              });
            }).catch(function (err) {
              console.log('err', err);
              _this6.$message({
                message: err.errorMessages[0],
                type: 'error'
              });
            }).finally(function () {
              _this6.loading.close();
            });
          }
        } else {
          return false;
        }
      });
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    addClick: function addClick() {
      this.dialogType = 'add';
      this.editDialog = true;
      this.billForm.portCode = 'CNSHA';
    }
  }
};